import {
  BOGGLE_LETTER_WEIGHTS,
  flattenBoggleLetterWeights,
} from '~/boggle/config/boardDistributions/letterWeights'
import type {
  BoggleChallengeVowelRatioBand,
  BoggleResolvedChallengeConfig,
  BoggleResolvedChallengeGameplay,
  BoggleResolvedChallengeMod,
} from '~/boggle/config/challenges/modTypes'
import type { LetterWeight } from '~/boggle/engine/core'
import { applyBoggleChallengeResolvedEffectToLetterWeights } from './applyResolvedEffect'

export function buildBoggleResolvedChallengeGameplayFromModifiers(
  modifiers: readonly BoggleResolvedChallengeMod[],
): BoggleResolvedChallengeGameplay {
  let letterWeights: ReadonlyArray<LetterWeight> = flattenBoggleLetterWeights(BOGGLE_LETTER_WEIGHTS)
  const runtimeHooks: string[] = []

  for (const mod of modifiers) {
    for (const effect of mod.effects) {
      if (effect.kind === 'letter-weights') {
        letterWeights = applyBoggleChallengeResolvedEffectToLetterWeights(
          letterWeights,
          effect,
        )
        continue
      }

      if (effect.kind === 'runtime-hook') {
        runtimeHooks.push(effect.hook)
      }
    }
  }

  return {
    letterWeights,
    runtimeHooks,
    vowelRatioBand: null,
  }
}

export function buildBoggleResolvedChallengeGameplay(
  resolvedChallenge:
    | (Pick<BoggleResolvedChallengeConfig, 'boardDistribution' | 'bonuses'> & {
        vowelRatioBand?: BoggleChallengeVowelRatioBand | null
      })
    | null,
): BoggleResolvedChallengeGameplay {
  const modifiers = resolvedChallenge
    ? resolvedChallenge.boardDistribution
      ? [resolvedChallenge.boardDistribution, ...resolvedChallenge.bonuses]
      : resolvedChallenge.bonuses
    : []

  const base = buildBoggleResolvedChallengeGameplayFromModifiers(modifiers)

  return {
    ...base,
    vowelRatioBand: resolvedChallenge?.vowelRatioBand ?? null,
  }
}
